import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  trigger() {
    if (this.hasUrlValue) {
      const win = window.open(this.urlValue, "_blank")
      if (win) {
        // Web fonts usually land before load, but nothing guarantees it; the
        // printout is set in the cookbook's fonts, so wait for them.
        win.addEventListener("load", () => win.document.fonts.ready.then(() => win.print()))
      } else {
        window.location = this.urlValue
      }
    } else {
      window.print()
    }
  }
}
